export type SettingsCategory =
  | 'account'
  | 'subscription'
  | 'payment'
  | 'coupon'
  | 'inquiry'
  | 'consent';

export const SETTINGS_CATEGORIES: {
  id: SettingsCategory;
  labelKey: string;
  icon: string;
}[] = [
  { id: 'account', labelKey: 'settingsDraft.account', icon: 'person' },
  { id: 'subscription', labelKey: 'settingsDraft.subscription', icon: 'workspace_premium' },
  { id: 'payment', labelKey: 'settingsDraft.payment', icon: 'credit_card' },
  { id: 'coupon', labelKey: 'settingsDraft.coupon', icon: 'confirmation_number' },
  { id: 'inquiry', labelKey: 'settingsDraft.inquiry', icon: 'support_agent' },
  { id: 'consent', labelKey: 'settingsDraft.consent', icon: 'policy' },
];

const VALID_IDS = new Set(SETTINGS_CATEGORIES.map((c) => c.id));

export function parseSettingsCategory(tab: string | null): SettingsCategory {
  if (tab && VALID_IDS.has(tab as SettingsCategory)) {
    return tab as SettingsCategory;
  }
  return 'account';
}

export function settingsPath(category: SettingsCategory) {
  return `/app/setting?tab=${category}`;
}

/** Legacy path → tab id */
export function legacyPathToTab(path: string): SettingsCategory | null {
  const map: Record<string, SettingsCategory> = {
    account: 'account',
    subscribtion: 'subscription',
    subscription: 'subscription',
    payment: 'payment',
    coupon: 'coupon',
    inquiry: 'inquiry',
    terms: 'consent',
    langauge: 'account',
  };
  return map[path] ?? null;
}
